export default "__VITE_ASSET__99fb5642__"